import { useEffect, useState } from 'react';
import { fetchPublicConfiguration } from '../../infrastructure/api/configuration.api';
import {
  emptyContact,
  emptyNetwork,
  type PublicConfiguration,
} from '../../application/types';

const emptyConfiguration: PublicConfiguration = {
  network: emptyNetwork(),
  publicContacts: emptyContact(),
  isPublicOffer: false,
  cachedAt: '',
};

export function usePublicConfiguration() {
  const [configuration, setConfiguration] =
    useState<PublicConfiguration>(emptyConfiguration);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    fetchPublicConfiguration()
      .then(next => {
        if (!cancelled) {
          setConfiguration(next);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setConfiguration(emptyConfiguration);
        }
      })
      .finally(() => {
        if (!cancelled) {
          setIsLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return { configuration, isLoading };
}
